import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import mobileDevIcon from '../../assets/images/icons/mobile-dev.gif';
import webDevIcon from '../../assets/images/icons/web-dev.gif';
import apiIcon from '../../assets/images/icons/api.gif';
import cloudIcon from '../../assets/images/icons/cloud.gif';
import maintenanceIcon from '../../assets/images/icons/maintenance.gif';
import testingIcon from '../../assets/images/icons/testing.gif';

const services = [
  {
    icon: mobileDevIcon,
    title: 'Mobile App Development',
    description: 'Android, iOS, React Native, Flutter',
    details: 'Native and cross-platform mobile applications with modern UI/UX and performance optimization.'
  },
  {
    icon: webDevIcon,
    title: 'Web Apps Development',
    description: 'React, Angular, Node, PHP, Laravel, CodeIgniter',
    details: 'Responsive web applications and platforms built with modern frameworks and best practices.'
  },
  {
    icon: apiIcon,
    title: 'API Design & Integration',
    description: 'REST, GraphQL, Swagger',
    details: 'Robust API development with comprehensive documentation and seamless integration.'
  },
  {
    icon: cloudIcon,
    title: 'Cloud Hosting & DevOps',
    description: 'AWS, Docker, CI/CD, S3',
    details: 'Cloud infrastructure setup, deployment automation, and scalable hosting solutions.'
  },
  {
    icon: maintenanceIcon,
    title: 'App Maintenance & Scaling',
    description: 'Bug fixes, optimizations, version upgrades',
    details: 'Ongoing support, performance optimization, and feature enhancements for existing applications.'
  },
  {
    icon: testingIcon,
    title: 'QA & Testing',
    description: 'Jest, Espresso, Unit Testing, Bug Reproduction',
    details: 'Comprehensive testing strategies including automated testing and quality assurance.'
  }
];

const Services: React.FC = () => {
  return (
    <section className="section services-section" id="services">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive software development solutions tailored to your business needs
          </p>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="service-card"
              >
                <div className="service-icon">
                  <img src={service.icon} alt={service.title} />
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-subtitle">{service.description}</p>
                <p className="service-details">{service.details}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services; 